import * as React from 'react'
import { SharepointPageType } from '../sharepointPageWidget'

export const BlocksLayout = (props: {
  pageType: SharepointPageType | 'home-logged-in'
  children: JSX.Element | JSX.Element[]
}) => <div className="page__content">{props.children}</div>
